import cloneDeep from 'lodash/cloneDeep';
import forEach from 'lodash/forEach';
import { action, extendObservable, makeObservable } from 'mobx';

class BaseStore {
  constructor(properties) {
    makeObservable(this, {
      initStoreProperties: action,
    });

    this.initStoreProperties(properties);
  }

  initStoreProperties = (properties) => {
    const clonedProperties = cloneDeep(properties);
    extendObservable(this, {
      ...clonedProperties,
      resetStore: () => {
        forEach(properties, (value, key) => {
          this[key] = value;
        });
      },
    });
  };
}

export default BaseStore;
